import React from "react";
import AppointmentMiniCard from "../global/AppointmentMinCard";

export default function MyHealthAppointments({
  upcoming = [],
  past = [],
  onOpenAppointment, // (appt) => void
}) {
  return (
    <section className="p2-myhealth-appt">
      <div className="p2-myhealth-appt-header">
        <p className="p2-myhealth-appt-title">
          Takimet e mia
        </p>
      </div>

      {/* Upcoming */}
      <div className="p2-myhealth-appt-block">
        <p className="p2-myhealth-appt-subtitle">
          Të ardhshme
          {upcoming.length > 0 && (
            <span className="p2-myhealth-appt-count">
              {" "}
              • {upcoming.length}
            </span>
          )}
        </p>
        {upcoming.length ? (
          upcoming.map((a) => (
            <button
              key={a.id}
              type="button"
              className="p2-myhealth-appt-item"
              onClick={() => onOpenAppointment?.(a)}
            >
              <AppointmentMiniCard appointment={a} isPast={false} />
            </button>
          ))
        ) : (
          <p className="p2-myhealth-appt-empty">
            Nuk ke takime të planifikuara.
          </p>
        )}
      </div>

      {/* Past */}
      <div className="p2-myhealth-appt-block p2-myhealth-appt-block--past">
        <p className="p2-myhealth-appt-subtitle">
          Të kaluara
          {past.length > 0 && (
            <span className="p2-myhealth-appt-count">
              {" "}
              • {past.length}
            </span>
          )}
        </p>
        {past.length ? (
          past.map((a) => (
            <button
              key={a.id}
              type="button"
              className="p2-myhealth-appt-item"
              onClick={() => onOpenAppointment?.(a)}
            >
              <AppointmentMiniCard appointment={a} isPast />
            </button>
          ))
        ) : (
          <p className="p2-myhealth-appt-empty">
            Ende nuk ke vizita të kaluara të regjistruara këtu.
          </p>
        )}
      </div>
    </section>
  );
}
